// extracted by mini-css-extract-plugin
export default {"footer":"P9KzA","footer-content":"_DQmX"};